import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Actions from './Actions';
import { handleError } from '../../shared/ErrorCatching';
import CommonTextModal from './CommonTextModal';
import notify from '../../shared/feedback/notifications';
import CommonTextList from './CommonTextList';

class CommonTextsPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            shouldShowModal: false,
            editId: -1
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.openCreateModal = this.openCreateModal.bind(this);
        this.deleteCommonText = this.deleteCommonText.bind(this);
    }

    componentDidMount(): void {
        this.props.actions.list().catch((error: any) => handleError(error));
    }

    openCreateModal(): void {
        this.setState({ editId: -1 });
        this.toggleModal();
    }

    toggleModal(): void {
        this.setState({ shouldShowModal: !this.state.shouldShowModal });
    }

    deleteCommonText(id: number) {
        this.props.actions
            .deleteCommonText(id)
            .then(() => {
                notify.success(Translate('common-texts/notification/common-text-deleted'));
            })
            .catch((error: any) => handleError(error));
    }

    render() {
        return (
            <div>
                <h1>{Translate('common-texts/page/title/common-texts')}</h1>
                <Button
                    bsSize="large"
                    className="pull-right"
                    onClick={this.openCreateModal}
                    bsStyle="success"
                >
                    {Translate('common-texts/modal/title/add-common-text')}
                </Button>
                {this.state.shouldShowModal && (
                    <CommonTextModal
                        editId={this.state.editId}
                        shouldShowModal={this.state.shouldShowModal}
                        closeModal={this.toggleModal}
                    />
                )}
                <CommonTextList items={this.props.commonTexts} delete={this.deleteCommonText} />
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        commonTexts: state.commonTexts.list.sort((a: any, b: any) => {
            return a.text.localeCompare(b.text, 'sv');
        })
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            list: () => dispatch(Actions.list()),
            deleteCommonText: (id: number) => dispatch(Actions.deleteCommonText(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CommonTextsPage);
